import React from 'react'
import styles from './Forms.scss'
import {OrderedMap, Set} from 'immutable'
import {CheckboxGroup} from 'common/styleguide/CheckboxGroup'
import {PillGroup} from 'common/styleguide/PillGroup'
import {RadioGroup, RadioButtonGroup} from 'common/styleguide/RadioGroup'
import {ButtonGroup} from 'common/styleguide/ButtonGroup'
import {DatePickerInput} from 'common/styleguide/DatePickerInput'
import {ImageUpload} from 'common/styleguide/ImageUpload'
import {CTA} from 'common/styleguide/CTA'
import {RangeInput} from 'common/styleguide/RangeInput'
import plusIcon from 'assets/images/goals/plusIcon.svg'

const vintage = OrderedMap({
  schwinn: 'Schwinn',
  peugeot: 'Peugeot',
  klein: 'Klein',
  cinelli: 'Cinelli',
  bianchi: 'Bianchi',
  derosa: 'De Rosa'
})

const climbs = OrderedMap({
  newberry: 'NW Newberry',
  tabor: 'Mt. Tabor',
  rockcreek: 'Rock Creek',
  fiftythird: 'NW 53rd',
  oldgermantown: 'Old Germantown'
})

// InputGroup components take an OrderedMap instead of a POJO so that
// keys can be non-string values. For example:
const groupsets = OrderedMap([
  [0, 'Shimano'],
  [1, 'Sram'],
  [2, 'Campagnolo']
])

export class Forms extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      selectedVintage: Set(['derosa', 'klein']),
      selectedClimb: 'newberry',
      selectedGroup: 0,
      selectedGroups: Set([0]),
      selectedDate: new Date(),
      selectedImage: null,
      rangeValue: 50,
      minMaxValue: { min: 2, max: 10 }
    }
  }

  onVintageChange = (selectedVintage) => {
    this.setState({selectedVintage})
  }

  onClimbChange = (selectedClimb) => {
    this.setState({selectedClimb})
  }

  onGroupsetChange = (selectedGroup) => {
    this.setState({selectedGroup})
  }

  onGroupsetsChange = (selectedGroups) => {
    this.setState({selectedGroups})
  }

  onDateChange = (selectedDate) => {
    this.setState({selectedDate})
  }

  onImageDrop = (files) => {
    if (files && files[0]) {
      this.setState({selectedImage: files[0]})
    }
  }

  onInputRangeChange = (value) => {
    this.setState({rangeValue: value})
  }

  onMinMaxRangeChange = (value) => {
    this.setState({minMaxValue: value})
  }

  render () {
    const {
      selectedVintage,
      selectedClimb,
      selectedGroup,
      selectedGroups,
      selectedDate,
      selectedImage,
      rangeValue,
      minMaxValue
    } = this.state

    const imgSrc = selectedImage
      ? selectedImage.preview
      : plusIcon

    return (
      <div className={styles.Forms}>
        <h1>Forms</h1>
        <div className={styles.demoBox}>
          <form>
            <div>
              <label htmlFor='textinput'>Text Input</label>
              <input id='textinput' type='text' />
            </div>
            <div>
              <label htmlFor='dateinput'>Date Input</label>
              <DatePickerInput
                id='dateinput'
                date={selectedDate}
                onDateChange={this.onDateChange} />
            </div>
            <div>
              <label htmlFor='imageupload'>Image Upload</label>
              <ImageUpload
                id='imageupload'
                onDrop={this.onImageDrop}
                hintTop={`Drop a photo here to upload`}>
                <img className={styles.imgPreview} height='90' src={imgSrc} />
              </ImageUpload>
            </div>
            <div>
              <label>Checkbox Group</label>
              <CheckboxGroup
                options={vintage}
                selected={selectedVintage}
                onChange={this.onVintageChange} />
            </div>
            <div>
              <label>Radio Group</label>
              <RadioGroup
                name='climbselector'
                options={climbs}
                selected={selectedClimb}
                onChange={this.onClimbChange} />
            </div>
            <div>
              <label>Radio Button Group</label>
              <RadioButtonGroup
                name='climbselectorbuttons'
                options={climbs}
                selected={selectedClimb}
                onChange={this.onClimbChange} />
            </div>
            <div>
              <label>Button Group</label>
              <ButtonGroup
                flex
                options={groupsets}
                selected={selectedGroup}
                onChange={this.onGroupsetChange} />
            </div>
            <div>
              <label>Pill Group</label>
              <PillGroup
                options={groupsets}
                selected={selectedGroups}
                onChange={this.onGroupsetsChange} />
            </div>
            <CTA>Submit</CTA>
            <div>
              Input ranges
              <RangeInput
                minValue={0}
                maxValue={100}
                value={rangeValue}
                onChange={this.onInputRangeChange} />
              {rangeValue} units
              <RangeInput
                minValue={0}
                maxValue={10}
                value={minMaxValue}
                onChange={this.onMinMaxRangeChange} />
              {minMaxValue.min} units - {minMaxValue.max} units
            </div>
          </form>
        </div>
      </div>
    )
  }
}
